export default "__VITE_ASSET__bfZNfTlj__"